export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-background-200/70 border border-background-300/40 overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="flex-1 p-8 md:p-12 lg:p-14">
              <span className="inline-block px-3 py-1 text-xs font-medium text-accent-300 bg-accent-500/10 rounded-full mb-4">
                联系我们
              </span>
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-4">
                联系我们
              </h2>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-8 max-w-[480px]">
                有任何观影建议、片源反馈或合作意向，欢迎通过以下方式联系我们。
                8848影院期待与每一位影迷共同成长。
              </p>
              <div className="space-y-4">
                <div className="flex items-center gap-4 p-4 rounded-xl bg-background-300/40 transition-all hover:bg-background-300/60 cursor-pointer">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10">
                    <i className="ri-mail-line text-accent-400 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">电子邮箱</div>
                    <div className="text-sm font-medium text-foreground-200">contact@8848cinema.com</div>
                  </div>
                </div>
                <div className="flex items-center gap-4 p-4 rounded-xl bg-background-300/40 transition-all hover:bg-background-300/60 cursor-pointer">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10">
                    <i className="ri-message-2-line text-primary-400 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">意见反馈</div>
                    <div className="text-sm font-medium text-foreground-200">在线提交建议</div>
                  </div>
                </div>
                <div className="flex items-center gap-4 p-4 rounded-xl bg-background-300/40 transition-all hover:bg-background-300/60 cursor-pointer">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10">
                    <i className="ri-shake-hands-line text-accent-400 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">商务合作</div>
                    <div className="text-sm font-medium text-foreground-200">partner@8848cinema.com</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-[380px] xl:w-[420px] min-h-[240px] lg:min-h-full bg-background-300/30 flex items-center justify-center p-8 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-accent-500/5 via-transparent to-primary-500/5"></div>
              <div className="relative text-center">
                <div className="w-20 h-20 flex items-center justify-center rounded-full bg-accent-500/10 mx-auto mb-4">
                  <i className="ri-customer-service-2-line text-accent-400 text-2xl"></i>
                </div>
                <div className="text-sm font-medium text-foreground-300 mb-1">客服在线时间</div>
                <div className="text-xs text-foreground-500">每日 9:00 - 24:00</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}